export default "/_next/static/chunks/fonts/Channel4Horseferry-ExtraBoldItalic-52a7d9bde0cd9b48a8f16dfc1953b3de.woff";